"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifyError = notifyError;
exports.notifyInfo = notifyInfo;

var _quasar = require("quasar");

function createNotification(message, color) {
  var multiLine = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  _quasar.Notify.create({
    color: color,
    position: 'top',
    message: message,
    icon: 'report_problem',
    multiLine: multiLine
  });
}

function notifyError(message) {
  var multiLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  createNotification(message, 'negative', multiLine);
}

function notifyInfo(message) {
  var multiLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  createNotification(message, 'primary', multiLine);
}